import React from 'react';
import Menu from '../compornent/Menu';
import FileListIndex from '../compornent/FileList/FileListIndex';

const FileList = (props: any) => {
  const { history } = props;

  return (
    <div className="main_contents">
      <Menu history={history} />
      <section id="right_contents" className="file">
        <FileListIndex history={history} />
      </section>
    </div>
  );
};
export default FileList;
